import format from 'date-fns/format';

export const getImportJobName = (createdAt: string) => {
  return `ImportJob ${format(Date.parse(createdAt), 'd-L-yyyy hh:mm:ss')}`;
};
